var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.noticeboards),function(noticeboard){return _c('q-list',{key:noticeboard.id},[_c('Noticeboard',{staticClass:"list-element",attrs:{"noticeboard":noticeboard}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }